import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { Color } from 'theme/enums';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onChangeEmployees?: () => void;
}

export const EmployeeWarning = ({ isOpen, onClose, onChangeEmployees }: IProps) => {
  const { t } = useTranslation();

  const handleOnChangeEmployees = onChangeEmployees
    ? () => {
        onClose();
        onChangeEmployees();
      }
    : undefined;

  return (
    <Confirmation
      isOpen={isOpen}
      color={Color.WARNING}
      title={t('titleEmployeeWarning')}
      message={t('messageEmployeeWarning')}
      confirmBtnLabel={t('buttonLabelChangeIsrOsr')}
      onConfirm={handleOnChangeEmployees}
      cancelBtnLabel={t('buttonLabelConfirm')}
      onCancel={onClose}
    />
  );
};
